package models

import kotlinx.serialization.Serializable

@Serializable
data class ProductModel(
    val id: Int,
    val name: String,
    val category: String
)